import { struct } from 'io-ts/Decoder';

import { Type } from '../../../../transaction/volumetrics/Type';

export const Request = struct({
	volumetrics: Type,
});
